"use client";

import { useEffect } from "react";
import { logError } from "@/utils/logError";
import { AppErrorScreen } from "@/components/ErrorBoundary/AppErrorScreen";

/**
 * Global error boundary for the Next.js App Router.
 *
 * This component catches unhandled errors at the root level and:
 * 1. Reports them to Sentry
 * 2. Displays a user-friendly error page with design system styling
 *
 * Note: This component must include <html> and <body> tags as it replaces
 * the root layout when an error occurs.
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    logError("Unhandled error caught by global error boundary", error, {
      app: "global",
      feature: "error-boundary",
      extra: { digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <AppErrorScreen />
      </body>
    </html>
  );
}
